export const YANDEX_SMARTCAPTCHA_CONFIG = {
  sitekey: process.env.GATSBY_YANDEX_SMARTCAPTCHA_SITEKEY || "",
};
